import { render } from "./DataTable.vue?vue&type=template&id=1bcc6778"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=1bcc6778&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bcc6778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bcc6778', __exports__)) {
    api.reload('1bcc6778', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=1bcc6778", () => {
    api.rerender('1bcc6778', render)
  })

}


export default __exports__